<ng-container>
    <div mat-dialog-title>
        <h2 *ngIf="!isUpdate">
            {{"restaurant.Add new Cancellation Policy" | translate}}
        </h2>
        <h2 *ngIf="isUpdate">
            {{"restaurant.Edit Cancellation Policy" | translate}}
        </h2>

        <button mat-icon-button class="close" (click)="openConfirmDialog()">
            <mat-icon class="pop-close">close</mat-icon>
        </button>
    </div>
    <form [formGroup]="formGroup">
        <mat-dialog-content>
            <div class="mat-dialog-body">
                <div class="fields-group">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="form-group mb-0" hideRequiredMarker>
                                <mat-label>{{"restaurant.Cancellation Policy Title in English" | translate}}</mat-label>
                                <input matInput formControlName="title_EN" maxlength="50">
                                <mat-error *ngIf="hasError('title_EN', 'required')">{{ 'forms.Required' | translate }}
                                </mat-error>
                                <!-- <mat-error *ngIf="hasError('title_EN', 'pattern')">
                                    {{ 'forms.EntervalidNameinEnglish' | translate }}
                                </mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field class="form-group mb-0" hideRequiredMarker>
                                <mat-label>{{"restaurant.Cancellation Policy Title in Arabic" | translate}}</mat-label>
                                <input matInput formControlName="title_AR" maxlength="50">
                                <mat-error *ngIf="hasError('title_AR', 'required')">{{ 'forms.Required' | translate }}
                                </mat-error>
                                <!-- <mat-error *ngIf="hasError('title_AR', 'pattern')">
                                    {{ 'forms.EntervalidNameinArabic' | translate }}
                                </mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <div class="d-flex align-items-center">
                                <b class="mr-2">{{"restaurant.Refund" | translate}}</b>
                                <mat-form-field class="font-12 field-align small-field" style="width: 70px" hideRequiredMarker>
                                    <input matInput [(ngModel)]="refund" formControlName="refund">
                                    <p matSuffix class="font-20">%</p>
                                    <mat-error *ngIf="hasError('refund', 'required')">
                                        {{ 'forms.Required' | translate }}
                                    </mat-error>
                                    <mat-error
                                        *ngIf="hasError('refund', 'pattern') || hasError('refund', 'min') || hasError('refund', 'max')">
                                        {{ 'forms.Invalid value' | translate }}
                                    </mat-error>
                                </mat-form-field>
                                <b class="ml-2">{{"restaurant.of Paid Deposit" | translate}}</b>
                            </div>
                        </div>
                        <div class="col-sm-12 mt-2">
                            <h4 class="group-title mb-0">{{"restaurant.Before booked reservations time by" | translate}}
                            </h4>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="field-align mt-1" hideRequiredMarker>
                                        <input matInput [(ngModel)]="period" formControlName="beforeTime"
                                            maxlength="10">
                                        <mat-error *ngIf="hasError('beforeTime', 'required')">{{ 'forms.Required' |
                                            translate }}
                                        </mat-error>
                                        <mat-error
                                        *ngIf="hasError('beforeTime', 'pattern')">
                                        {{ 'forms.Invalid value' | translate }}
                                    </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-form-field class="form-group" hideRequiredMarker>
                                        <mat-label>{{ 'restaurant.Intervals' | translate }}</mat-label>
                                        <mat-select formControlName="beforeTimeType"
                                        (selectionChange)="onPeriodUnitChange($event)">
                                            <mat-option [value]="interval.value" *ngFor="let interval of Intervals">
                                                <span>{{interval.name}}</span>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-sm-12 ">
                            <h4 class="group-title mb-0">{{"restaurant.After the guest submit the reservation by" |
                                translate}}</h4>

                            <div class="row ">
                                <div class="col-md-6">
                                    <mat-form-field class="field-align mt-1" hideRequiredMarker>
                                        <input matInput [(ngModel)]="time" formControlName="afterTime"
                                            maxlength="10">
                                        <mat-error *ngIf="hasError('afterTime', 'required')">{{ 'forms.Required' |
                                            translate }}
                                        </mat-error>
                                        <mat-error
                                        *ngIf="hasError('afterTime', 'pattern')">
                                        {{ 'forms.Invalid value' | translate }}
                                    </mat-error>
                                    </mat-form-field>

                                </div>
                                <div class="col-md-6">
                                    <mat-form-field class="form-group" hideRequiredMarker>
                                        <mat-label>{{ 'restaurant.Intervals' | translate }}</mat-label>
                                        <mat-select formControlName="afterTimeType"
                                        (selectionChange)="onTimeUnitChange($event)" >
                                            <mat-option [value]="interval.value" *ngFor="let interval of Intervals">
                                                <span>{{interval.name}}</span>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div> -->
                        <div class="col-sm-12">
                            <h4 class="group-title mb-0">{{"content3.Summary" |
                                translate}} <span class="info no-icon">({{'restaurant.Viewable by Guests' |
                                    translate}})</span></h4>

                            <div class="grey-list-items mt-2">
                                <div class="list-item border border-raduis">
                                    <div class="d-flex align-items-center">
                                        <p class="font-16">{{"restaurant.You will get" | translate}} {{refund}}%
                                            {{"restaurant.Refund" | translate}},
                                            {{"restaurant.if you cancel within" | translate}} {{period}} {{periodUnit}}
                                        </p>
                                    </div>
                                </div>
                                <div class="list-item border-raduis dashed">
                                    <div class="d-flex align-items-center">
                                        <p class="mr-3 info">{{"restaurant.This summary is auto generated from configuration defined above and will be shown for guests on BonTech Mobile App" | translate }}</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>

            <button mat-raised-button color="primary" (click)="saveRecord()" [disabled]="loading"
                [class.loading]="loading" *ngIf="!isUpdate">
                {{"restaurant.Add Cancellation Policy" | translate}}
            </button>
            <button mat-raised-button color="primary" (click)="saveRecord()" [disabled]="loading"
                [class.loading]="loading" *ngIf="isUpdate">
                {{"restaurant.Update Cancellation Policy" | translate}}
            </button>

        </mat-dialog-actions>
    </form>
</ng-container>
